import PropTypes from 'prop-types';

export default PropTypes.shape({
  count: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired
});
